import { nanoid } from 'nanoid';

import i18n from '@sola/locales/index.js';
import { GraphQLSupporterPaymentMethod } from '@sola/schema/dotcom/supporters/schema.generated.js';

import { LocalAlertConfig, LocalAlertCreateProps } from '../types/localeAlerts';
import { CTA_CONTACT_SUPPORT } from './ctas';

/**
 * Function for creating local alert data with an id.
 */
export const createLocalAlert = (
  alertProps: LocalAlertCreateProps,
): LocalAlertConfig => {
  return { id: nanoid(), ...alertProps };
};

export const createPaymentMethodSuccessAlert = (
  { creditCard, ach }: GraphQLSupporterPaymentMethod,
  actionTranslationKey: string,
): LocalAlertCreateProps => {
  const { t } = i18n;
  let lastFour = creditCard?.lastFour || '';
  let type = creditCard?.cardType || '';

  if (ach) {
    lastFour = ach.lastFourOfAccountNumber || '';
    type = t('my:payments.ach.accountTypes.checking');
  }

  return {
    translationKey: 'payments.success',
    variant: 'positive',
    translationData: {
      lastFour,
      type,
      action: t(`my:${actionTranslationKey}`),
    },
  };
};

export const createSupportAlert = (translationKey: string) => {
  const { t } = i18n;
  return createLocalAlert({
    translationKey,
    variant: 'negative',
    dismissible: true,
    action: i18n.exists(`${CTA_CONTACT_SUPPORT.translation}`) ? (
      <a href={CTA_CONTACT_SUPPORT.url} rel="noreferrer" target="_blank">
        {t(CTA_CONTACT_SUPPORT.translation)}
      </a>
    ) : undefined,
  });
};
